<template>
  <section>
    <div class="row">
      <div class="col-md-12 mt-2" v-if="selectedAccount">
        <label><b>Selected Zone:</b> {{ (selectedZone) ? `${selectedZone.name} (${selectedZone.id})` : 'None'}}</label><br>
        <multi-select
            class="mt-1"
            v-model="selectedZone"
            :options="allZones"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            label="name"
            :max-height="200"
            placeholder="Select Zone"
        />
        <span v-if="!loading && !allZones.length" class="text-danger">No zone found for this account!</span>
      </div>
      <div v-if="loading" class="col-md-12">
        <div class="loader">
        </div>
      </div>
      <div v-else-if="!loading && !selectedAccount" class="col-md-12">
        <div class="p-3 text-danger">
          Please Select Account
        </div>
      </div>
      <div class="col-md-12">
        <section v-if="selectedZone" class="pt-3">
          <dns @update-loading="updateLoading" :index="1" :account="account" :records="allDNS" :loading="dnsLoader"></dns>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import Dns from "./../../Admin/ManageTenants/dns";
import multiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: "zoneList",
  props: {
    selectedAccount: {
      type: Object
    }
  },
  components: {
    multiSelect,
    Dns
  },
  data() {
    return {
      allZones: [],
      allDNS: [],
      loading: false,
      collapseIndex: -1,
      account: {},
      selectedZone: null,
      dnsLoader: false
    }
  },
  watch: {
    selectedAccount: {
      deep: true,
      immediate: true,
      handler (val) {
        if(val){
          if(val.selectedZone){
            this.selectedZone = val.selectedZone
          }else{
            this.selectedZone = null
          }
          this.fetchAllZones()
        }
      }
    },
    selectedZone: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.allDNS = []
          this.fetchAllDNS()
        }
      }
    }
  },
  methods: {
    updateLoading(value){
      if (!value) {
        this.fetchAllDNS(this.selectedZone)
      }
      this.dnsLoader = value;
    },
    async fetchAllZones(){
      try{
        this.allZones= []
        this.loading= true
        let resp = await this.$http.post('tenant/list-zones-under-account',{
          grant_type:'token',
          accountId: this.selectedAccount.id
        });
        console.log('zones', resp.data)
        this.allZones = resp.data.result

      }catch (e) {
        console.log('Error from fetching all acounts under tenant' + e.toString())
      } finally {
        this.loading=false
      }
    },
    async fetchAllDNS(){
      const data = this.selectedZone
      try {
        this.allDNS= []
        this.dnsLoader = true
        this.account = {
          domain: data.name,
          cloudflare: {
            username: 'tenant',
            apiKey: 'tenant',
            zone_id: data.id
          }
        }
        let resp = await this.$http.post('tenant/get-dns',{
          grant_type:'token',
          zoneId: data.id
        });
        this.allDNS = resp.data.data
      } catch (e) {
        console.log('Error from fetching all dns under zone' + e.toString())
      } finally {
        this.dnsLoader = false
      }
    }

  }
}
</script>

<style scoped lang="scss">
.accounts-list {
  height: 68vh;
  overflow-y: scroll;
}
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  hr {
    border-top: 1px solid rgba(255,255,255,.5);
  }
}
table{
  tr {
    .task-width {
      width:70%;
    }
    td {
      /deep/  p {
        margin: 0 !important;
      }
    }
  }
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;
    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
    &.default {
      color: currentColor;
    }
    &:hover{
      background-color:transparent !important;
      color: currentColor !important;
    }
  }
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
</style>
